export const relatedLinks: any[] = [];
